/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignMetricsResponseSchema } from '../campaign-schema';

export const getCampaignMetricsPathSchema = z.object({
  campaignId: z.string(),
});

export const getCampaignMetricsOperationResponseSchema =
  campaignMetricsResponseSchema;

export type GetCampaignMetricsInput = {
  path: z.input<typeof getCampaignMetricsPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignMetrics({
  path,
  signal,
}: GetCampaignMetricsInput): Promise<
  z.infer<typeof getCampaignMetricsOperationResponseSchema>
> {
  const parsedPath = getCampaignMetricsPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/metrics`,
    {
      signal,
    },
  );
  return getCampaignMetricsOperationResponseSchema.parse(await response.json());
}
